module.exports = __webpack_public_path__ + "img/iphone-rfidcard-POLAND-pl.24f583d0.png";